import script from "./workplace.vue?vue&type=script&lang=ts&setup=true"
export * from "./workplace.vue?vue&type=script&lang=ts&setup=true"

import "./workplace.vue?vue&type=style&index=0&id=db61ce0e&lang=less&scoped=true"

import exportComponent from "D:\\test\\ieds-user-end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-db61ce0e"]])

export default __exports__